/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Autosave_HintInputs */

const en_case_autosave_hint = /** @type {(inputs: Case_Autosave_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft auto-saves every 30 seconds.`)
};

const pt_br2_case_autosave_hint = /** @type {(inputs: Case_Autosave_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho salvo automaticamente a cada 30 segundos.`)
};

/**
* | output |
* | --- |
* | "Draft auto-saves every 30 seconds." |
*
* @param {Case_Autosave_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_autosave_hint = /** @type {((inputs?: Case_Autosave_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Autosave_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_autosave_hint(inputs)
	return pt_br2_case_autosave_hint(inputs)
});